import {
  DataModelBuilder, SerializationContext, SerializedData,
} from '../../../../dto/data-model.js';
import { AuditLogEntry } from '../../audit-log-entry.js';
import { EventTicketOrder } from '../../../event-ticket-order.js';
import { MapUtils } from '../../../../../utility/map-utils.js';
import {
  cloneData, isSameData,
} from '../../../../dto/data-model-utils.js';
import { AuditLogEntryType } from '../../audit-log-entry-type.js';

export class OfflineEventTicketOrderCreatedEntry extends AuditLogEntry {
  static readonly TYPE_ID: string = 'e762a23821074e119b79b8a511311dbd';

  private constructor(
    public readonly order: EventTicketOrder,
  ) {
    super();
  }

  get $typeId(): string {
    return OfflineEventTicketOrderCreatedEntry.TYPE_ID;
  }

  get type(): AuditLogEntryType {
    return AuditLogEntryType.OfflineEventTicketOrderCreated;
  }

  generateQueryData(): SerializedData {
    return {
      businessRef: this.order.businessRef.encode(),
      eventId: this.order.eventId,
      orderId: this.order.uniqueId,
    };
  }

  static create(args: {
    order: EventTicketOrder,
  }): OfflineEventTicketOrderCreatedEntry {
    return new OfflineEventTicketOrderCreatedEntry(
        args.order,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): OfflineEventTicketOrderCreatedEntry {
    return this.create({
      order: context.fromData(MapUtils.getRecord(map, 'order')),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      order: context.toData(this.order),
    };
  }

  clone(): this {
    return OfflineEventTicketOrderCreatedEntry.create({
      order: cloneData(this.order),
    }) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.order, this.order);
  }
}

export class OfflineEventTicketOrderCreatedEntryBuilder extends DataModelBuilder<OfflineEventTicketOrderCreatedEntry> {
  build(context: SerializationContext, map: SerializedData): OfflineEventTicketOrderCreatedEntry {
    return OfflineEventTicketOrderCreatedEntry.fromMap(context, map);
  }
}
